import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientSearchScreen } from 'screens/patient';

export default withPermissions(PatientSearchScreen, [
  GroupSecurity.FeaturePreviewAISearch,
  GroupSecurity.FeaturePreviewAI,
]);
